import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/introduce',
      name: 'introuduce',
      component: () => import('./views/Introduce.vue')
    },
    {
      path: '/join',
      name: 'join',
      component: () => import('./views/joinUs.vue')
    },
    {
      path: '/members',
      name: 'members',
      component: () => import('./views/Members.vue')
    },
    {
      path: '/capability',
      name: 'capability',
      component: () => import('./views/Capability.vue')
    },
    {
      path: '/regulations',
      name: 'regulations',
      component: () => import('./views/Regulations.vue')
    },
    {
      path: '/detail/:id',
      name: 'detail',
      component: () => import('./views/Detail.vue')
    },
    {
      path: '/redownload',
      name: 'redownload',
      component: () => import('./views/Download.vue')
    },
    {
      path: '/emailJump',
      name: 'emailJump',
      component: () => import('./views/emailJump.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./views/register.vue')
    },
    {
      path: '/personalinfo',
      name: 'personalinfo',
      component: () => import('./views/UserInfo.vue')
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

export default router
